import { render, staticRenderFns } from "./OpenTickets.vue?vue&type=template&id=4c0796b6&"
import script from "./OpenTickets.vue?vue&type=script&lang=js&"
export * from "./OpenTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports